export default "__VITE_ASSET__RmWYQf6$__"